module.exports = __webpack_public_path__ + "static/img/613_phase_function_Paper_Points.47e70b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/613_phase_function_Paper_Points.png
// module id = gEAb
// module chunks = 0